<template>
  <div>
    <Header></Header>
    <section>
      <div class="page_map">
        <ol class="breadcrumb">
          <li><router-link to="/">Home</router-link></li>
        </ol>
      </div>
      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th>{{ $t("site.Targetname") }}</th>
              <th>{{ $t("site.Probename") }}</th>
              <th width="380">{{ $t("site.Siteslist") }}</th>
              <th>{{ $t("site.Sitesvisualization") }}</th>
              <th>{{ $t("site.datasource") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, key) in  list " :key="key" :style="setstyle(v)">
              <td>
                <div>{{ ProteinId }}</div>
              </td>
              <td>{{ v.ProbeId }}</td>
              <td>
                <div>{{ v.Site }}</div>
              </td>
              <td>
                <div class="site_img" @click="siteOpen(v.wdgif,LDDBid,v.ProbeId)">
                  <img v-if="v.wdgif.val&&v.wdgif.val.url" :src="v.wdgif.val ? v.wdgif.val.url : ''" />

                  <img v-if="v.wdgif.val&&!v.wdgif.val.url" :src="setimg(v.wdgif,LDDBid,v.ProbeId)" />
                  <!-- <div class="nums">{{ v.wdgif.length }}</div> -->
                </div>
              </td>
              <td>
                <a href="javascript:void(0)" @click="sourcesOpen(v.essayid)">{{ v.essayid }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </section>

    <div class="pop_bg" v-show="popBgShow" @click="closeAll()"></div>
    <div class="pop_data_sources" v-show="popSourcesShow">
      <div class="header_info">
        <div class="title">数据来源{{ syData.datacode }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： {{ syData.experimentnumber }}<br>
        实验日期：{{ syData.implementationdate ? syData.implementationdate : "" }}<br>
        实验设计（模板）：<div v-html="syData.designexperiments"></div>
      </div>
    </div>

    <div class="pop_site_imgages" v-show="popSiteShow" >


      <div class="wrapper">
        <swiper ref="mySwiper" v-bind:options="swiperOptions">
          <swiper-slide v-for=" (val, key) in showpic['val']" :key="key">
            <div><img :src="val ? val.url : ''" /></div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev swiper-button-prevsp" slot="button-prev"></div>
        <div class="swiper-button-next swiper-button-nextsp" slot="button-next"></div>
      </div>

      <div class="footer_btn">
        <a href="javascript:void(0)" @click="downloadpic()">立即下载</a>
      </div>
    </div>


    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  components: {
    Header,
    Footer,
    swiper,
    swiperSlide
  },
  data() {
    return {
      popBgShow: false,
      popSourcesShow: false,
      popSiteShow: false,
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      list: [],
      EntryName: "",
      ProbeId: "",
      showpic: [],
      syData: {},
      isarticle: false,
      LDDBid: "",
      ProbeId: "",
      ProteinId:""
    }
  },

  created() {
    this.getdetailData()
  },
  methods: {
    setimg(wdgif,LDDBid,ProbeId){
      var allimg=wdgif.val&&!wdgif.val.url ? wdgif.val : [];
      var getimg=LDDBid+"_"+ProbeId;
      var url="";
      allimg.forEach(function(val){
        var nname=val.fileName.split('.');
        if(getimg==nname[0]){
          url=val.url;
          return;
        }
      });
      return url;
    },
    downloadpic(){
      var that=this;
      var showpic=that.showpic['val'];
      showpic.forEach((v,i)=>{
        setTimeout(() => {
          const x = new XMLHttpRequest()
          x.open("GET", v.url, true)
          x.responseType = 'blob'
          x.onload=function(e) {
              const url = window.URL.createObjectURL(x.response)
              const a = document.createElement('a')
              a.href = url
              a.target = '_blank'
              a.download = v.fileName
              a.click()
              a.remove()
          }
          x.send()
        }, i*1000);
      })

    },
    setstyle(val) {
      if (val.vindex % 2 == 0) {
        return "background: #fff;";
      }
      return "background: #f4f7fb;";
    },
    resetVal(val) {
      let newval = "";
      if (val == undefined) {
        return newval;
      }

      val.forEach(function (item) {
        newval += item + "<br>";
      })
      return newval;
    },
    resetHtmlVal(val) {
      let newval = "";
      if (val == undefined) {
        return newval;
      }
      //console.log(val);
      let arr = val.split("\n");
      arr.forEach(function (item) {
        newval += item + "<br>";
      });
      return newval;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }
    },
    sourcesClose() {
      this.popBgShow = false;
      this.popSourcesShow = false;
    },
    siteOpen(wdgif,LDDBid,ProbeId) {
      var allimg=wdgif.val&&!wdgif.val.url ? wdgif.val : [];
      var getimg=LDDBid+"_"+ProbeId;
      var url="";
      var urlname="";
      allimg.forEach(function(val){
        var nname=val.fileName.split('.');
        if(getimg==nname[0]){
          url=val.url;
          urlname=val.fileName;
          return;
        }
      });
      this.showpic =[];
      if(url) this.showpic = {"val":[{'url':url,'fileName':urlname}]};
      this.popBgShow = true;
      this.popSiteShow = true;
    },
    closeAll() {
      this.popBgShow = false;
      this.popSourcesShow = false;
      this.popSiteShow = false;
    },
    async getdsjyData(val) {
      //查询数据源
      var that = this;
      var postdata = {
        "datacode": val
      };
      that.isarticle = false;
      let urllist = '/action/egxqivukrqpdlzsjz/getdata';
      if (val.indexOf('LDRA') != -1) {
        urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        that.isarticle = true;
      }
      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.syData = res.data.rows[0];
          if (that.isarticle) {
            window.open(that.syData.essayurl);
          }
        }
      });
    },
    async getdetailData() {
      //查询详情
      var that = this;
      that.LDDBid = this.$route.query.LDDBid;
      that.ProbeId = this.$route.query.ProbeId;
      that.ProteinId=this.$route.query.ProteinId;

      let urllist = '/action/eburqcjqvjtgtgwcx/getwd';
      await api.getTableData(urllist, JSON.stringify({ LDDBid: that.LDDBid, ProbeId: that.ProbeId })).then(res => {
        if (res.data) {
          that.list = [];
          let newlist = res.data.rows;
          newlist.forEach(function (v) {
            let one = JSON.parse(JSON.stringify(v));
            let LDDBidArr = one.LDDBid.split('\n');
            var oneLDDBid = LDDBidArr.indexOf(that.LDDBid);
            let SitesListArr = [];
            if (one.SitesList) {
              SitesListArr = one.SitesList.split('\n');
            }
            one.Site = SitesListArr[oneLDDBid];
            if (SitesListArr[oneLDDBid]) {
              that.list.push(one);
            }
          })
        }
      });

    }
  }
}


</script>



// WEBPACK FOOTER //
// src/views/Site.vue